import script from "./BaseSearchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSearchInput.vue?vue&type=script&setup=true&lang=js"

import "./BaseSearchInput.vue?vue&type=style&index=0&id=038c667c&lang=scss&scoped=true"

import exportComponent from "/Users/acatohw/Development/openwebconcept/app/public_html/wp-content/plugins/openkaarten-frontend-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038c667c"]])

export default __exports__